import React from "react";
import { EntityDataHooksContext } from "../context/entity-data-hooks-context";
export var useEntityDataHooks = function () {
  return React.useContext(EntityDataHooksContext) || {};
};
export var useEntityDataHook = function (entityTypeName) {
  var hooks = useEntityDataHooks();
  return hooks[entityTypeName] || function () {
    return [];
  };
};